import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { withRouter } from 'react-router';
import idx from 'idx';
import {
  createUserRequest, updateUserLocal, updateUser, logout, setAgencySegment
} from 'common/ducks/user';
import { setUnhandledError, setBannerError } from 'error/ducks';
import { showBanner } from 'common/ducks/banner';
import {
  fetchBriefQuestions, fetchCategoriesIfNeeded, getCategory, getSubCategory
} from 'common/ducks/categories';
import { fetchProjectIfNeeded, updateProjectLocal } from 'project/ducks/project';
import {
  displayFullScreen, hideFullScreen, setLazyRegistering, LAZY_REGISTRATION_STEP_BRIEF_ALL,
  AGENCY_STEP, toggleAgencyQuestion
} from 'pap/ducks/workflow';
import {
  createProjectRequest, updateProjectRequest, updateAttachments, fetchAttachments
} from 'pap/ducks/project';
import { getVisibleBriefQuestions } from 'pap_v2/utils';
import { fetchDiscountCode } from 'pap/ducks/pricing';
import BriefAll from 'pap_v2/components/brief_all';

const FORM_NAME = 'pap_brief_all_v2';

const mapStateToProps = (state, { params, location }) => {
  const { user, categories, pap } = state;
  const { fullScreen, lazyRegistering, showingAgencyQuestion } = pap.workflow;
  const { attachments } = pap.project;
  const { projectId } = params;
  const { origin='direct' } = location.query;
  const project = pap.project.projectData || {};
  let briefQuestions, categorySlug, subCategorySlug;

  if (projectId) {
    const category = getCategory(categories.data, project.category);
    const subCategory = getSubCategory(categories, project.sub_category);
    subCategorySlug = subCategory? subCategory.slug : '';
    categorySlug = category? category.slug : '';
    briefQuestions = project.brief_questions || [];
  } else {
    categorySlug = params.categorySlug;
    subCategorySlug = params.subCategorySlug;
    briefQuestions = categories.briefQuestions || [];
  }

  const questions = getVisibleBriefQuestions(briefQuestions);

  /* insert agency question if not already answered */
  if (showingAgencyQuestion) {
    questions.splice(0, 0, AGENCY_STEP);
  }

  /* insert account creation question if lazy registering */
  if (lazyRegistering) {
    questions.splice(0, 0, LAZY_REGISTRATION_STEP_BRIEF_ALL);
  }

  const selector = formValueSelector(FORM_NAME);
  const currentEmail = idx(selector(state, 'create-account'), _ => _.email);
  const currentIsAgency = selector(state, 'is_agency');

  let initialValues = {};
  if (user.logged_in) {
    initialValues['create-account'] = { email: user.profile_data.email };
  }
  if (projectId) {
    initialValues = {
      ...initialValues,
      ...project.brief_answers,
      file_upload: attachments
    };
  }
  if (user.profile_data.is_agency_question_answered) {
    initialValues = {
      ...initialValues,
      is_agency: (
        currentIsAgency !== undefined?
        currentIsAgency :
        (user.profile_data.marketing_segments.includes("agency")? "yes" : "no")
      )
    };
  }

  return {
    user,
    lazyRegistering,
    showingAgencyQuestion,
    questions,
    fullScreen,
    origin,
    categorySlug,
    subCategorySlug,
    projectId,
    currentEmail,
    initialValues,
    attachments: projectId? attachments : [],
    categories: categories.data,
    fetchingQuestions: briefQuestions.length === 0,
  }
}

const wrappedBriefAll = reduxForm({
  form: FORM_NAME,
  enableReinitialize: true,
})(BriefAll);

export default withRouter(connect(mapStateToProps, {
  fetchCategoriesIfNeeded,
  fetchBriefQuestions,
  setLazyRegistering,
  toggleAgencyQuestion,
  showBanner,
  createUserRequest,
  updateUserLocal,
  createProjectRequest,
  updateAttachments,
  setUnhandledError,
  fetchDiscountCode,
  displayFullScreen,
  hideFullScreen,
  fetchProjectIfNeeded,
  fetchAttachments,
  updateProjectRequest,
  updateProjectLocal,
  setBannerError,
  updateUser,
  setAgencySegment,
  logout
})(wrappedBriefAll));



// WEBPACK FOOTER //
// ./pap_v2/containers/brief_all.js